import { CAMPAIGN_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { CampaignRowView } from './types';

export function buildCampaignQueueItem(row: CampaignRowView): ApprovalQueueItem {
  return {
    categoryId: CAMPAIGN_CATEGORY.id,
    categoryLabel: CAMPAIGN_CATEGORY.label,
    description: `${row.field}${row.packageName ? ` for ${row.packageName}` : ''} requires approval.`,
    details: [
      { label: 'Value', value: row.value },
      { label: 'Rule', value: row.rule },
      { label: 'Evidence', value: row.evidence },
      { label: 'Source', value: row.source },
      ...(row.action ? [{ label: 'Action', value: row.action }] : []),
    ],
    id: row.id,
    title: row.field,
  };
}

export function getCampaignSearchText(row: CampaignRowView) {
  return [row.field, row.packageName, row.value, row.rule, row.evidence, row.source, row.statusLabel, row.action]
    .filter(Boolean)
    .join(' ');
}
